import React from 'react';
import { SmallBodyText } from 'ui-toolkit/components/Typography/basicTypography';
import { Notification } from 'ui-toolkit/components/Notification/Notification';

export const NotificationMessage = (
  <Notification
    type={'warning'}
    mode={'inverted'}
    message={
      <SmallBodyText>
        Changing the Property Address will result in some documents to be regenerated. You should also check if a new
        title search is required.
      </SmallBodyText>
    }
  />
);
